import FormInput from "../../../../components/FormInput/FormInput";
import AnalysisSection from "../AnalysisSection/AnalysisSection";
import { WorkflowInfoSectionProps } from "./WorkflowInfoSection.types";
import "./WorkflowInfoSection.css"
import EllipsisMenu from "../../../../components/EllipsisMenu/EllipsisMenu";
import SkeletonLoadingView from "../../../../components/SkeletonLoadingView/SkeletonLoadingView";

const WorkflowInfoSection = (props: WorkflowInfoSectionProps) => {
  const { 
    workflow,
    section,
    ellipsisMenu
   } = props

  const skeletonLoadingHeight = "6rem"

  if (workflow === undefined || section === undefined) {
    return (
      <AnalysisSection title="Workflow">
        <>
          <div className="analysis-section">
            <SkeletonLoadingView style={{height: skeletonLoadingHeight}} />
          </div>

          <div className="workflow-info-grid">
            <div className="analysis-section">
              <SkeletonLoadingView style={{height: skeletonLoadingHeight}} />
            </div>

            <div className="analysis-section">
              <SkeletonLoadingView style={{height: skeletonLoadingHeight}} />
            </div>
          </div>
        </>
      </AnalysisSection>
    )
  }
  
  return (
    <AnalysisSection title="Workflow" titleChild={
      <EllipsisMenu
        ellipsisMenu={ellipsisMenu}
      />
    }>
      <div className="analysis-section">
        <div className="workflow-info-container">
          <FormInput
            label={"Database ID:"} input={
              {
                value: `${workflow.id}`,
                onChange: () => {},
                placeholder: undefined,
                error: undefined
              }
            }
            disabled={true}
          />

          <FormInput
            label={"Asset ID:"} input={
              {
                value: workflow.pipe_id,
                onChange: () => {},
                placeholder: undefined,
                error: undefined
              }
            }
            disabled={true}
          />

          <FormInput
            label={"Pipe Length:"} input={
              {
                value: `${workflow.pipe_length}`,
                onChange: () => {},
                placeholder: undefined,
                error: undefined
              }
            }
            disabled={true}
          />

          <FormInput
            label={"Pipe Diameter:"} input={
              {
                value: `${workflow.pipe_diameter}`,
                onChange: () => {},
                placeholder: undefined,
                error: undefined
              }
            }
            disabled={true}
          />
          
          <FormInput
            label={"Pipe Temperature:"} input={
              {
                value: `${workflow.pipe_temp}`,
                onChange: () => {},
                placeholder: undefined,
                error: undefined
              }
            }
            disabled={true}
          />
          
          <FormInput
            label={"Pipe Location:"} input={
              {
                value: `${workflow.location}`,
                onChange: () => {},
                placeholder: undefined,
                error: undefined
              }
            }
            disabled={true}
          />
          
          <FormInput
            label={"Asset Type:"} input={
              {
                value: "PIPE",
                onChange: () => {},
                placeholder: undefined,
                error: undefined
              }
            }
            disabled={true}
          />
          
          <FormInput
            label={"Workflow Start:"} input={
              {
                value: `${workflow.start}`,
                onChange: () => {},
                placeholder: undefined,
                error: undefined
              }
            }
            disabled={true}
          />
          
          <FormInput
            label={"Workflow End:"} input={
              {
                value: `${workflow.end}`,
                onChange: () => {},
                placeholder: undefined,
                error: undefined
              }
            }
            disabled={true}
          />
          
          <FormInput
            label={"Tracing Cable:"} input={
              {
                value: workflow.has_tracing_cable ? "Yes" : "No",
                onChange: () => {},
                placeholder: undefined,
                error: undefined
              }
            }
            disabled={true}
          />
        </div>
      </div>

      <div className="workflow-info-grid">
        <div className="analysis-section">
          <div className="workflow-info-container">

            <FormInput
              label={"Section Start:"} input={
                {
                  value: `${section.start}`,
                  onChange: () => {},
                  placeholder: undefined,
                  error: undefined
                }
              }
              disabled={true}
            />
            
            <FormInput
              label={"Section End:"} input={
                {
                  value: `${section.end}`,
                  onChange: () => {},
                  placeholder: undefined,
                  error: undefined
                }
              }
              disabled={true}
            />
            
            <FormInput
              label={"Section Type:"} input={
                {
                  value: `${section.section_type}`,
                  onChange: () => {},
                  placeholder: undefined,
                  error: undefined
                }
              }
              disabled={true}
            />

            
            <FormInput
              label={"Pi360:"} input={
                {
                  value: `${section.device_id}`,
                  onChange: () => {},
                  placeholder: undefined,
                  error: undefined
                }
              }
              disabled={true}
            />
          </div>
        </div>

        <div className="analysis-section">
          <div className="workflow-info-container">
            <FormInput
              label={"Cladding Material:"} input={
                {
                  value: workflow.cladding_material,
                  onChange: () => {},
                  placeholder: undefined,
                  error: undefined
                }
              }
              disabled={true}
            />
            
            <FormInput
              label={"Cladding Thickness:"} input={
                {
                  value: `${workflow.cladding_thickness}`,
                  onChange: () => {},
                  placeholder: undefined,
                  error: undefined
                }
              }
              disabled={true}
            />
              
              <FormInput
              label={"Insulation Material:"} input={
                {
                  value: workflow.insulation_material,
                  onChange: () => {},
                  placeholder: undefined,
                  error: undefined
                }
              }
              disabled={true}
            />
            
            <FormInput
              label={"Insulation Thickness:"} input={
                {
                  value: `${workflow.insulation_thickness}`,
                  onChange: () => {},
                  placeholder: undefined,
                  error: undefined
                }
              }
              disabled={true}
            />
          </div>
        </div>
      </div>
    </AnalysisSection>
  )
}

export default WorkflowInfoSection